module.exports = __webpack_public_path__ + "static/img/persoonlijke_supervisie_header2.2681bb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/persoonlijke_supervisie_header2.jpg
// module id = M9J3
// module chunks = 0